export enum GigTypes {
  SET_ENDING_LIVE_SUCCESS = 'SET_ENDING_LIVE_SUCCESS',
  TERMINATE_GIG = 'TERMINATE_GIG',
  SET_LIVE_TIME = 'SET_LIVE_TIME',
  SET_GOING_LIVE = 'SET_GOING_LIVE',
  UNSET_GOING_LIVE = 'UNSET_GOING_LIVE',
  SET_GOING_LIVE_SUCCESS = 'SET_GOING_LIVE_SUCCESS',
  ENDING_LIVE_CONFIRMED = 'ENDING_LIVE_CONFIRMED',
  SET_ENDING_LIVE = 'SET_ENDING_LIVE',
  UNSET_ENDING_LIVE = 'UNSET_ENDING_LIVE',
  EXTEND_GIG_TERMINATION = 'EXTEND_GIG_TERMINATION',
  EXTEND_GIG_TERMINATION_SUCCESS = 'EXTEND_GIG_TERMINATION_SUCCESS'
}